import React, { useState, useEffect, useRef } from "react";
import Controller from './Controller.js';
import { gsap, TweenLite } from "gsap";
import HotspotText from "./HotspotText";
gsap.registerPlugin(TweenLite);



const HotspotMedia = ({mediaType, file, title, text}) => {
    const el = useRef(null); 
    const progressRef = useRef(null); 
    const circleRef = useRef(null);
    const [mode, setMode] = useState(null)
    useEffect(()=>{      
        el.current.controls = false;  
        const pathLength = circleRef.current.getTotalLength();
        TweenLite.set(circleRef.current, {strokeDasharray:pathLength});
    },[]);

    const animateProgressBar = value => {
        const width = 100 - value
        const pathLength = circleRef.current.getTotalLength();
        TweenLite.fromTo(circleRef.current, 0, {strokeDashoffset: pathLength}, {strokeDashoffset:width });
    }

    const handleTimeChange = () => {
        let value;
        if (el.current.currentTime > 0) {
            value = Math.floor((100 / el.current.duration) * el.current.currentTime)
        }
        animateProgressBar(value)
    }
    
    const togglePlayPause = e => {
        let playpause = e.target;
        if (mediaType === "video") {
            if (e.target.classList.contains("video")) {
                playpause = e.target.nextElementSibling;
            } else {
                playpause = e.target;
            }
        }
        if (el.current.paused || el.current.ended) {
            playpause.title = "pause";
            el.current.play();
            setMode("play")
        }
        else {
            playpause.title = "play";
            el.current.pause();
            setMode("pause")
        }
    }

    const PauseHandler = e => {
        e.target.pause();
        setMode("pause");
    }

    return (
        <div className={mediaType==="video" ? "video-container" : "audio-container"}>
            <div className="media-container">
                {mediaType === "video"? (
                    <video onClick={togglePlayPause} onPause={PauseHandler} className="video" width="250" ref={el} onTimeUpdate={handleTimeChange} preload="auto" loop playsInline>
                        <source src={file} type="video/mp4"></source>
                        {/* <source src="http://clips.vorwaerts-gmbh.de/VfE_html5.mp4" type="video/mp4"></source> */}
                        Your browser does not support the<code>video</code> element.
                    </video>
                ) : (
                    <audio src={file} className="audio" ref={el} onTimeUpdate={handleTimeChange} onPause={PauseHandler}>
                        Your browser does not support the<code>audio</code> element.
                    </audio>
                )}
                <Controller mode={mode} togglePlayPause={togglePlayPause} el={mediaType==="video" ? "video" : "audio"} circleRef={circleRef}/>

                <div className="progressBar">
                    <span ref={progressRef} className="progress"></span>
                </div>

            </div>
            <HotspotText title={title} text={text} />
        </div>
    )
}

export default HotspotMedia;